<template>
  <div>
    <vue-cookie-accept-decline
      :ref="'myPanel1'"
      :elementId="'myPanel1'"
      :debug="false"
      :position="'bottom-left'"
      :type="'floating'"
      :disableDecline="true"
      :transitionName="'slideFromBottom'"
      :showPostponeButton="false"
      @status="cookieStatus"
      @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline"
    >
      <div slot="postponeContent">
        &times;
      </div>
 
      <div slot="message">
        We use cookies to ensure you get the best experience on our website. <router-link to="CookieDetails">more...</router-link>
      </div>
 
      <div slot="declineContent">
        OPT OUT
      </div>
 
      <div slot="acceptContent">
        GOT IT!
      </div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
// Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
export default {
  components : {
    'vue-cookie-accept-decline' : VueCookieAcceptDecline
  },
  methods: {
    cookieStatus(){},
    cookieClickedAccept(){},
    cookieClickedDecline(){}
  }
}
</script>